import { render, staticRenderFns } from "./S2Textarea.vue?vue&type=template&id=f87007e8&scoped=true"
import script from "./S2Textarea.vue?vue&type=script&lang=js"
export * from "./S2Textarea.vue?vue&type=script&lang=js"
import style0 from "./S2Textarea.vue?vue&type=style&index=0&id=f87007e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f87007e8",
  null
  
)

export default component.exports